import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const widgetContainerCss = "w119pr8m";
export const WidgetContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(widgetContainerCss, props.className)} />;
});
const sectionHeaderCss = "s1az1fap";
export const SectionHeader = forwardRef((props, ref) => {
  const {
    expanded,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const sectionBodyCss = "s1oxhnxj";
export const SectionBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionBodyCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");